import { PaperPlaneTiltIcon } from '@phosphor-icons/react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { Formik } from 'components/form/formik';
import * as Yup from 'yup';

import { Button } from '../../../../components/button/Button';
import { useCustomer } from '../Customer/customerContext';
import { InputField } from '../../../../components/input/InputField';
import { getDisplayError } from '../../../../utils/get-display-error';
import { inviteCustomerUser } from '../../models';
import { captureException } from '@sentry/react';
import { trackEvent } from '../../../../utils/track-event';

const inviteCustomerUserSchema = Yup.object().shape({
  email: Yup.string().email().required('Vereist'),
});

export const InviteCustomerUserPage = () => {
  const navigate = useNavigate();
  const { customer, refreshData } = useCustomer();

  return (
    <div>
      <h2 className="heading-two mb-4">Nodig gebruiker uit</h2>

      <Formik
        initialValues={{
          email: '',
        }}
        validationSchema={inviteCustomerUserSchema}
        onSubmit={async (values) => {
          try {
            await inviteCustomerUser(customer.id, values.email);
            refreshData();
            trackEvent('customer_user_invited', { customer_id: customer.id });
            toast.success('Gebruiker uitgenodigd');
            navigate('..');
          } catch (err: any) {
            captureException(err);
            toast.error('Kon gebruiker niet uitnodigen: ' + getDisplayError(err));
          }
        }}
      >
        {({ handleSubmit, isSubmitting }) => (
          <form onSubmit={handleSubmit}>
            <InputField labelText="Email" type="email" name="email" />

            <Button
              type="submit"
              color="primary"
              isDisabled={isSubmitting}
              isLoading={isSubmitting}
              iconLeft={<PaperPlaneTiltIcon className="button-icon" />}
            >
              Nodig gebruiker uit
            </Button>
          </form>
        )}
      </Formik>
    </div>
  );
};
